import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const mfaRequiredInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  const excludedRoutes = [
    '/auth/mfa',
    '/auth/logout',
    '/logout',
  ];

  if (excludedRoutes.some(route => req.url.includes(route))) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isMfaRequired =
        error.status === 403 &&
        error.error?.code === 'SVC-4003';

      if (isMfaRequired) {
        const currentUrl = router.url;

        // Prevent redirect loop
        if (!currentUrl.startsWith('/auth/mfa')) {
          router.navigate(['/auth/mfa'], {
            queryParams: { returnUrl: currentUrl },
          });
        }
      }

      return throwError(() => error);
    })
  );
};
